var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.47944 2.58442C7.42593 2.5067 7.35432 2.44315 7.27079 2.39925C7.18726 2.35534 7.09431 2.33241 6.99995 2.33241C6.90558 2.33241 6.81263 2.35534 6.7291 2.39925C6.64557 2.44315 6.57396 2.5067 6.52045 2.58442L1.27044 10.1678C1.20968 10.2552 1.17404 10.3577 1.16741 10.464C1.16078 10.5703 1.1834 10.6764 1.23283 10.7707C1.28226 10.865 1.35659 10.944 1.44776 10.9991C1.53893 11.0542 1.64344 11.0832 1.74995 11.083L12.2499 11.083C12.3562 11.0826 12.4603 11.0532 12.5511 10.998C12.6419 10.9428 12.716 10.8639 12.7653 10.7698C12.8146 10.6756 12.8373 10.5699 12.831 10.4638C12.8247 10.3577 12.7896 10.2554 12.7294 10.1678L7.47944 2.58442Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.e86b860755297ec8cf6b7bcfd99811e0.svg";
export { ForwardRef as ReactComponent };